import { FileUpload } from "components/RFQ/FileUpload";
import { removeProgressFromUploading } from "utils/rfxLargeFileUploadHelper";

export const RSFileUploadRFX = ({
	setFieldValue,
	rfqId,
	setUploadInProgresses,
}) => {
	const handleFileUploadComplete = (uploadedFile) => {
		const filePath = uploadedFile?.returnableScheduleFilePath?.file_path;

		if (filePath) {
			setFieldValue("returnable_schedule_file", uploadedFile);
			setFieldValue("returnable_schedule_file_path", filePath);
			setFieldValue("returnable_schedule_file_id", null);
		} else {
			setFieldValue("returnable_schedule_file", null);
			setFieldValue("returnable_schedule_file_path", "");
			setFieldValue("returnable_schedule_file_id", null);
		}

		setUploadInProgresses((prev) => removeProgressFromUploading(prev, true));
	};

	return (
		<FileUpload
			name="returnable_schedule_file"
			types={["pdf", "docx", "doc", "xlsx", "xls"]}
			required
			singleFile
			setFieldValue={setFieldValue}
			label="Upload Returnable Schedules"
			description="Please upload your returnable schedule"
			fileExtraData={{
				model: "rfq_returnable_schedule_file",
				rfq_id: rfqId,
			}}
			handleFileUploadComplete={handleFileUploadComplete}
			isProcurerRFx
			testId="returnable-schedule-file"
		/>
	);
};
